import branding from './branding.json';

export const APP_NAME = branding.name;
export const APP_SHORT_NAME = branding.shortName;
export const APP_DESCRIPTION = branding.description;

const appConfig = {
    APP_NAME,
    APP_SHORT_NAME,
    APP_DESCRIPTION,
};

export default appConfig;
